module.exports = [
  {
    "AgeGroup": "45-54 years",
    "Race": "Black, not Hispanic",
    "Year": "2000",
    "Rate": 793.87
  },
  {
    "AgeGroup": "45-54 years",
    "Race": "Black, not Hispanic",
    "Year": "2002-2004",
    "Rate": 769.63
  },
  {
    "AgeGroup": "45-54 years",
    "Race": "Black, not Hispanic",
    "Year": "2005-2007",
    "Rate": 722.67
  },
  {
    "AgeGroup": "45-54 years",
    "Race": "Black, not Hispanic",
    "Year": "2010",
    "Rate": 638.9
  },
  {
    "AgeGroup": "45-54 years",
    "Race": "Black, not Hispanic",
    "Year": "2011-2013",
    "Rate": 591.37
  },
  {
    "AgeGroup": "45-54 years",
    "Race": "Black, not Hispanic",
    "Year": "2014-2016",
    "Rate": 581.3
  },
  {
    "AgeGroup": "45-54 years",
    "Race": "Black, not Hispanic",
    "Year": "2018",
    "Rate": 585.2
  },
  {
    "AgeGroup": "45-54 years",
    "Race": "White, not Hispanic",
    "Year": "2000",
    "Rate": 388.6
  },
  {
    "AgeGroup": "45-54 years",
    "Race": "White, not Hispanic",
    "Year": "2002-2004",
    "Rate": 401.77
  },
  {
    "AgeGroup": "45-54 years",
    "Race": "White, not Hispanic",
    "Year": "2005-2007",
    "Rate": 407.17
  },
  {
    "AgeGroup": "45-54 years",
    "Race": "White, not Hispanic",
    "Year": "2010",
    "Rate": 411.07
  },
  {
    "AgeGroup": "45-54 years",
    "Race": "White, not Hispanic",
    "Year": "2011-2013",
    "Rate": 413.57
  },
  {
    "AgeGroup": "45-54 years",
    "Race": "White, not Hispanic",
    "Year": "2014-2016",
    "Rate": 418.73
  },
  {
    "AgeGroup": "45-54 years",
    "Race": "White, not Hispanic",
    "Year": "2018",
    "Rate": 413.5
  }
]
